import { formatCurrency, formatDecimal, formatPercentage } from '@/common/utils/formatters';

const formatters = {
  currency: formatCurrency,
  percent: formatPercentage,
  integer: (v: number) => formatDecimal(v, 2, 0),
}

export const barChartLabelFormatter = (v: string | number, format?: string, emptyFallback?: string | number) => {
  if ((!Number(v) && format !== 'string') || (!v && format === 'string') && emptyFallback) {
    return emptyFallback;
  }

  const formatter = formatters[(format || 'integer') as keyof typeof formatters]
  const formattedValue = formatter ? formatter(Number(v) || 0) : v

  return `${formattedValue}`
}
